<template>
  <v-dialog v-model="localDialog" max-width="980px" scrollable persistent>
    <v-card>
      <v-card-title class="text-h5 blue lighten-2">
        <span>{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-simple-table v-if="bookingSummary" class="mb-4">
            <tbody>
              <tr>
                <th>Booking</th>
                <td>
                  <strong>B{{ bookingSummary.booking_id }}</strong>
                </td>
                <th>Added On</th>
                <td>{{ bookingSummary.added_on }}</td>
              </tr>
              <tr>
                <th>Instructor</th>
                <td>
                  A{{ bookingSummary.adi_id }} - {{ bookingSummary.adi_name }}
                </td>
                <th>Learner</th>
                <td>
                  L{{ bookingSummary.learner_id }} -
                  {{ bookingSummary.learner_name }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <div v-if="!loading && threadBubbles.length">
            <v-row
              v-for="bubble in threadBubbles"
              :key="bubble.id"
              :justify="bubble.actor_type === 'instructor' ? 'start' : 'end'"
              no-gutters
              class="mb-3"
            >
              <v-col cols="12" md="9">
                <v-card :class="bubbleCardClass(bubble)" class="thread-bubble">
                  <v-card-title class="pb-1 pt-3 px-4 d-flex align-center">
                    <span class="text-subtitle-2">
                      {{ bubbleTitle(bubble) }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="bubble.status === 0"
                      small
                      color="red"
                      text-color="white"
                    >
                      Removed
                    </v-chip>
                  </v-card-title>

                  <v-card-subtitle class="pt-3 pb-3 px-4 bubble-time">
                    {{ bubble.created_on | dateReOrder }}
                  </v-card-subtitle>

                  <v-card-text class="pt-0 px-4 pb-4">
                    <template v-if="bubble.kind === 'logs'">
                      <v-simple-table dense class="bubble-table">
                        <tbody>
                          <tr
                            v-for="record in bubble.records"
                            :key="record.record_id"
                          >
                            <th class="question-col">
                              {{ record.question_text }}
                            </th>
                            <td class="answer-col">
                              {{ record.reflective_answer }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </template>

                    <template v-else>
                      <p class="mb-0 answer-col">{{ bubble.note }}</p>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>

          <v-alert
            v-if="!loading && !threadBubbles.length"
            type="info"
            outlined
          >
            No reflective log records found for this booking.
          </v-alert>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ReflectiveThreadDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    bookingSummary: {
      type: Object,
      default: null,
    },
    threadBubbles: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.closeDialog();
        }
      },
    },
    dialogTitle() {
      if (!this.bookingSummary) {
        return "Reflective Logs";
      }
      return `Reflective Logs - Booking B${this.bookingSummary.booking_id}`;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    bubbleTitle(bubble) {
      if (bubble.kind === "logs") {
        return bubble.actor_type === "instructor"
          ? "Instructor Reflective Logs"
          : "Learner Reflective Logs";
      }
      return bubble.actor_type === "instructor"
        ? "Instructor Additional Note"
        : "Learner Additional Note";
    },
    bubbleCardClass(bubble) {
      if (bubble.status === 0) {
        return "grey lighten-3";
      }
      if (bubble.actor_type === "instructor") {
        return "green lighten-5";
      }
      return "blue lighten-5";
    },
  },
};
</script>

<style scoped>
.thread-bubble {
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.bubble-time {
  opacity: 0.85;
}

.bubble-table {
  background: transparent;
}

.bubble-table :deep(table),
.bubble-table :deep(thead),
.bubble-table :deep(tbody),
.bubble-table :deep(tr),
.bubble-table :deep(th),
.bubble-table :deep(td),
.bubble-table :deep(.v-data-table__wrapper) {
  background: transparent !important;
}

.question-col {
  width: 35%;
  vertical-align: top;
  padding: 10px 12px 10px 0;
}

.answer-col {
  word-break: break-word;
  white-space: pre-line;
  padding: 10px 0;
}
</style>
